import { differenceInCalendarDays, isSameDay } from 'date-fns';
/** Return `true` whether the given date is inside the range. */
export function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (!from) {
        return false;
    }
    if (!to && isSameDay(from, date)) {
        return true;
    }
    if (!to) {
        return false;
    }
    var isToBeforeFrom = differenceInCalendarDays(to, from) < 0;
    if (to && isToBeforeFrom) {
        _a = [to, from], from = _a[0], to = _a[1];
    }
    return (differenceInCalendarDays(date, from) >= 0 &&
        differenceInCalendarDays(to, date) >= 0);
}
//# sourceMappingURL=isDateInRange.js.map